

import React, { memo, useCallback, useState } from 'react';
import cx from 'classnames';
import SortIcon from './SortIcon';
import { SORT_ICON_SIZE_DEFAULT } from '../constants/sortIconSize';
import { SORT_ICON_NAME } from '../constants/sortIconName';
import { SORT_DIRECTION } from '../../../../common/constants/sortDirection';


import { getNextSortValue } from '../utils/sortValue';
import '../styles/_sort.scss';










const Sort = (props) => {
  const {
    className,
    size = SORT_ICON_SIZE_DEFAULT,
    hasNoSort = true,
    value,
    onClick,
    children
  } = props;

  const [isHovered, setIsHovered] = useState(false);

  const isAsc = value === SORT_DIRECTION.ASC;
  const isDesc = value === SORT_DIRECTION.DESC;

  const onContainerClick = useCallback(
    () => onClick && onClick(
      getNextSortValue(value, hasNoSort)
    ), [value, hasNoSort, onClick]
  );

  const onMouseEnter = useCallback(
    () => setIsHovered(true), [value, hasNoSort, onClick]
  );

  const onMouseLeave = useCallback(
    () => setIsHovered(false), [value, hasNoSort, onClick]
  );
  return (
    <button
      type="button"
      className={cx('sort', className)}
      onClick={onContainerClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}>

      {children && <div className="sort__title">{children}</div>}

      <div className="sort__icons">
        <SortIcon name={SORT_ICON_NAME.ASC} size={size} isActive={isAsc} isHovered={isHovered} />

        <SortIcon name={SORT_ICON_NAME.DESC} size={size} isActive={isDesc} isHovered={isHovered} />
      </div>
    </button>);

};

export default memo(Sort);